/**
 * Chat bubble (WhatsApp) + ledger tick (Tally) — the product's two endpoints.
 * A mark of our own instead of a generic ShopOutlined/antd icon, so the brand is recognizable.
 */
export const Logo = ({ size = 28 }: { size?: number }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16 3C8.82 3 3 8.36 3 15c0 3.06 1.24 5.85 3.28 7.98L5 29l6.4-1.9A14.2 14.2 0 0 0 16 27c7.18 0 13-5.36 13-12S23.18 3 16 3Z"
      fill="#25D366"
    />
    <path
      className="logo-tick"
      pathLength={1}
      d="M11 15.5l3.2 3.2L21.5 11.5"
      stroke="#0B141A"
      strokeWidth={2.4}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
